// extracted by mini-css-extract-plugin
export default {"root":"TikEZVXU","main":"Zb9HCsoZ","list":"OkzedQdM","item":"_2Q4m0ZVS"};